<template>
  <!-- MODAL EDIT -->
  <b-modal
    :id="'editLocation' + idData"
    title="แก้ไขชื่อจุดติดตั้ง"
    size="md"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @ok="submitEdit"
  >
    <b-row>
      <b-col
        md="12"
        lg="12"
      >
        <b-row>
          <b-col
            md="12"
            lg="12"
          >
            <b-form-group
              label="ชื่อจุดติดตั้ง - กม.0+000"
              label-for="basicInput"
            >
              <b-form-textarea
                id="basicInput"
                v-model="editData.location_name"
                placeholder="ชื่อติดตั้ง"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- basic -->
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
/* eslint-disable global-require */
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormTextarea,
  },
  props: {
    idData: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      editData: {
        location_name: '',
        pj_code: '',
        location_id: '',
      },
    }
  },
  mounted() {
  },
  methods: {
    sendInfo() {
      axios
        .post('/fetchELocation', {
          pj_code: this.$route.query.pj_code,
          location_id: this.idData,
        })
        .then(response => {
          this.editData.location_name = response.data.location_name
          this.editData.pj_code = this.$route.query.pj_code
          this.editData.location_id = this.idData
        })
        .catch(error => {
          console.log(error)
        })
    },
    submitEdit() {
      this.$swal({
        title: '<span style="color:#000000">ต้องการเปลี่ยนชื่อจุดจิดตั้ง ?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง',
      }).then(result => {
        if (result.isConfirmed) {
          try {
            axios.post('/editELocation', this.editData)
            this.$swal({
              icon: 'success',
              title: '<span style="color:#000000">แก้ไขเรียบร้อย</span>',
              showConfirmButton: false,
              timer: 1500,
            })
            this.$emit('fetch')
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.map{
  width: 100%;
  height: 600px;
}
.vue2leaflet-map {
    &.leaflet-container{
    position: absolute;
    width: 100% - 1;
    height: 568px;
    }
}

</style>
